export const formatLastSavedDate = (date: Date): string => {
  if (!date) {
    return '';
  }
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const isToday = date >= today;
  const isYesterday = date >= yesterday && date < today;

  const formatTime = (date: Date): string => {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    const hours12 = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    return `${hours12}:${formattedMinutes}${ampm}`;
  };

  if (isToday) {
    return `Today, ${formatTime(date)}.`;
  } else if (isYesterday) {
    return `Yesterday, ${formatTime(date)}.`;
  } else {
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
    return `${day} ${month}, ${year}, ${formatTime(date)}.`;
  }
};
